import { render, staticRenderFns } from "./Tda.vue?vue&type=template&id=5bbd30cc&scoped=true"
import script from "./Tda.vue?vue&type=script&lang=js"
export * from "./Tda.vue?vue&type=script&lang=js"
import style0 from "./Tda.vue?vue&type=style&index=0&id=5bbd30cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd30cc",
  null
  
)

export default component.exports